import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SECTORS } from "@/lib/omSectors";
import Footer from "@/components/Footer";
import { useMeta } from "@/lib/useMeta";
import { NAVY, GOLD, MUTED } from "@/components/om/OmBits";
import { SectorNav } from "@/pages/om/SectorNav";

export default function OmSectors() {
  useMeta({
    title: "O&M Management Built for Every Sector | Plan-Sarthi",
    description:
      "Plan-Sarthi's Operations and Maintenance module is purpose-built for India's most critical infrastructure sectors — solar, wind, thermal, nuclear, hydro, HVAC, oil and gas, water, highways and manufacturing.",
    path: "/om/sectors",
  });

  return (
    <div style={{ background: NAVY, fontFamily: "Inter, system-ui, sans-serif" }} data-testid="om-sectors-hub">
      <SectorNav />
      <section className="px-5 sm:px-8 py-16 sm:py-24 max-w-[1280px] mx-auto text-center">
        <h1 className="font-bold leading-[1.08] text-3xl sm:text-5xl" style={{ color: GOLD, letterSpacing: "0.01em" }}>
          O&amp;M Management Built for Every Sector
        </h1>
        <p className="text-white mt-5 text-[15px] sm:text-[17px] max-w-3xl mx-auto leading-relaxed">
          Plan-Sarthi's Operations and Maintenance module is purpose-built for India's most critical infrastructure
          sectors — from Solar farms to Nuclear plants.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link to="/signup" className="w-full sm:w-auto text-center font-semibold" style={{ background: GOLD, color: NAVY, borderRadius: 8, padding: "12px 28px" }} data-testid="hub-trial-btn">
            Start Free Trial
          </Link>
          <Link to="/contact" className="w-full sm:w-auto text-center font-semibold border" style={{ borderColor: GOLD, color: GOLD, borderRadius: 8, padding: "12px 28px" }} data-testid="hub-demo-btn">
            Book a Demo
          </Link>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-20 max-w-[1280px] mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SECTORS.map((s) => (
            <Link
              key={s.slug}
              to={`/om/sectors/${s.slug}`}
              className="group relative block overflow-hidden border transition-all duration-300 hover:-translate-y-1"
              style={{ borderColor: "rgba(201,168,76,0.2)", borderRadius: 8, minHeight: 300 }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = GOLD; e.currentTarget.style.boxShadow = `0 0 0 1px ${GOLD}, 0 18px 40px rgba(201,168,76,0.18)`; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(201,168,76,0.2)"; e.currentTarget.style.boxShadow = "none"; }}
              data-testid={`sector-card-${s.slug}`}
            >
              <img src={s.hero} alt={s.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" style={{ animation: "fadeIn 0.6s ease" }} />
              <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(10,22,40,0.35) 0%, rgba(10,22,40,0.92) 72%)" }} />
              <div className="relative h-full flex flex-col justify-end p-5" style={{ minHeight: 300 }}>
                <h2 className="text-white font-bold text-[19px] leading-snug">{s.name}</h2>
                <p className="text-[12.5px] mt-1.5 leading-relaxed" style={{ color: MUTED }}>{s.short}</p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-[12.5px] font-semibold self-start" style={{ background: GOLD, color: NAVY, borderRadius: 8, padding: "9px 18px" }}>
                  Explore {s.name} <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
